import React from "react";
import { AddNewTest } from "../modules/AddNewTest";

export function AddNewTestPage() {
  return <AddNewTest />;
}
